import React, { type ReactNode } from 'react';
import { Currency } from 'src/components/currency';
import { Text } from 'src/components/text/Text';
import { type CurrencyType } from 'src/types/currency';

import styles from './CurrencyAmount.css';

interface Props {
  children: ReactNode;
  currency: CurrencyType;
  currencyPosition?: 'start' | 'end';
  suffix?: ReactNode;
}

export const CurrencyAmount = ({
  children,
  currency,
  currencyPosition = 'start',
  suffix,
}: Props) => {
  const amount = (
    <Text as="strong" variant="body2TightBold">
      {children}
      {currencyPosition === 'start' && suffix}
    </Text>
  );

  return (
    <span className={styles.CurrencyAmount}>
      {currencyPosition === 'start' ? (
        <>
          <Currency currency={currency} />
          {'\u00a0'}
          {amount}
        </>
      ) : (
        <>
          {amount}
          {'\u00a0'}
          <Currency currency={currency} />
          {suffix != null && (
            <Text as="strong" variant="body2TightBold">
              {suffix}
            </Text>
          )}
        </>
      )}
    </span>
  );
};
